import { render, staticRenderFns } from "./DonateView.vue?vue&type=template&id=20af78e6&"
import script from "./DonateView.vue?vue&type=script&lang=js&"
export * from "./DonateView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports